import TestimonialKarte from '@/components/TestimonialKarte';

/* Testimonial-Frage am Ende des Ergebnis- und Abschluss-Check-ups (Brief W1.7, Paket w1-testimonial).
   Der Stepper-Client trägt `testimonial` (CRM: testimonialCrm(leadId), /coach: testimonialCoach(coach, leadId)). Am
   Studio-Tablet gibt es keinen — dort fehlt die Anmeldung mit Rechten; das Mitglied willigt dann in der App ein.
   Die Karte zeigt die Frage (gesperrt mit Hinweis, solange die Leitung den Text nicht freigegeben hat), Zuschnitt und Stand. */
export default function TestimonialAmEnde({ client }) {
  if (!client?.testimonial) return null;
  return <TestimonialKarte client={client.testimonial} testId="checkup-testimonial" />;
}
